export enum TypeChangementProduitCode {
    REPLI = 'REPLI',
    RENONCEMENT = 'RENONCEMENT',
    DECLASSEMENT = 'DECLASSEMENT',
    CHANGEMENT_DENO = 'CHANGEMENT_DENO',
    TIRAGE = 'TIRAGE'
}
